import { render, staticRenderFns } from "./studentAudioTask_exam.vue?vue&type=template&id=e6015812&"
import script from "./studentAudioTask_exam.vue?vue&type=script&lang=js&"
export * from "./studentAudioTask_exam.vue?vue&type=script&lang=js&"
import style0 from "./studentAudioTask_exam.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports